import type { Metric } from '../types/executive'

export const metrics: Metric[] = [
  {
    value: '$850M+',
    label: 'Capital & Contract Awards Secured',
    detail: 'Cumulative institutional, healthcare, aviation, and civic programs',
  },
  {
    value: '35+ Years',
    label: 'Construction Management Leadership',
    detail: 'Including 15+ years of multi-state regional executive oversight',
  },
  {
    value: '$1M Turnaround',
    label: 'Healthcare P&L Reengineered',
    detail: 'From a $1M operating loss to $1M net profit',
  },
  {
    value: '$585M',
    label: 'Aviation Portfolio Delivered',
    detail: '$460M LAX terminal cores completed with zero critical claims',
  },
]
